import React, { useState } from 'react';
import { SelectDD, ExternalDD } from '../../common/dropdowns';
import { relocateType } from '../../appConstants';
import { visaType } from '../../appConstants';
import avatar1 from '../../assets/avatar-1.jpg';

function ProfiledAspirants(props) {
    
    return (
         
    <div className="card"  >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Profiled Aspirants</h5>
            </div>
            <div className="card-header-right">
                <button className="btn btn-primary">Save View</button> 
                <button className="btn btn-primary">Contact</button>                   
            </div>
            
        </div>
        <div className="card-block">
            <div className="v-align">
            <div className="wd-pct-2"></div>
                <div className="wd-pct-7"></div>
                <div className="wd-pct-17">Name</div>
                <div className="wd-pct-24">Expertise</div>
                <div className="wd-pct-10">Experience</div>
                <div className="wd-pct-12">Qualification</div>
                <div className="wd-pct-19">Subject</div>
                <div className="wd-pct-3"></div>    
                <div className="wd-pct-3"></div>
                <div className="wd-pct-3"></div>          
            </div>
            <div className="v-align">
                <div className="wd-pct-2 checkbox-fade fade-in-primary">
                    <label>
                        <input type="checkbox" ></input>
                        <span className="cr">
                            <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                        </span>  
                    </label>
                </div>
                <div className="wd-pct-7">
                    <img className="img-radius-50 ht-40 wd-40" alt="Avatar" src={avatar1} style={{float: 'left'}}  />
                </div>
                <div className="wd-pct-17">John Doe</div>
                <div className="wd-pct-24">Web&Software Development</div>
                <div className="wd-pct-10">3.2 yrs</div>
                <div className="wd-pct-12">BTech.</div>
                <div className="wd-pct-19">Computer Science</div>
                <div className="wd-pct-3 text-center">
                    <i className="far fa-user"></i>
                </div>    
                <div className="wd-pct-3 text-center">
                    <i className="far fa-id-badge"></i>
                </div>       
                <div className="wd-pct-3 text-center">
                    <i className="far fa-trash-alt"></i>
                </div>          
            </div>
        </div>
    </div>
    );
  }

export default ProfiledAspirants